import { render, staticRenderFns } from "./off.vue?vue&type=template&id=03615c50&scoped=true&"
import script from "./off.vue?vue&type=script&lang=js&"
export * from "./off.vue?vue&type=script&lang=js&"
import style0 from "./off.vue?vue&type=style&index=0&id=03615c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03615c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03615c50')) {
      api.createRecord('03615c50', component.options)
    } else {
      api.reload('03615c50', component.options)
    }
    module.hot.accept("./off.vue?vue&type=template&id=03615c50&scoped=true&", function () {
      api.rerender('03615c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/goods/off.vue"
export default component.exports